/**
 * @method: to call reducer
 */
import { actionType } from "../search/action";
import defaultState from '../../../store/defaultStore';
import ReactGA from 'react-ga4';
let defaultStore = defaultState;
const reducer = (state = defaultStore, action) => {

     switch (action.type) {
          case actionType.GET_PAGE_DATA_REQUEST:
               state = { ...state, ...defaultState.searchReducer.pageData };

               break;
          case actionType.GET_PAGE_DATA_RECEIVED:
               defaultState.searchReducer.pageData = action.payload;
               state = { ...state, ...defaultState.searchReducer }

               break;
          case actionType.SEARCH_ARTICLE_REQUEST:
               defaultState.searchReducer.isEventTriggered = false;

               state = { ...state, ...defaultState.searchReducer };
               break;
          case actionType.SEARCH_ARTICLE_SUCCESS:
               if (action.viewMore) {
                    if (state.articleList.data && action.payload.data.articles.length > 0) {
                         action.payload.data.articles = state.articleList.data.articles.concat(action.payload.data.articles);
                    }
               }

               if (!defaultState.searchReducer.isEventTriggered) {
                    defaultState.searchReducer.isEventTriggered = true;

                    if (state.searchOption.search_key === "free-text") {
                         ReactGA.event('Click',{
                              category: 'SearchByKeyword',
                              action: 'Click',
                              event_category: 'SearchByKeyword',
                              event_action: 'Click',
                              event_label: `${state.searchOption.search_value}`,
                              event_value: action.payload.data.total,
                              UserID: (defaultState.auth.userId) ?  defaultState.auth.userId : 'noAuth'
                         })
                    } else {
                         ReactGA.event('Click',{
                              category: 'SearchByCategory',
                              action: 'Click',
                              event_category: 'SearchByCategory',
                              event_action: 'Click',
                              event_label: defaultState.searchReducer.selectedEventSearchOption,
                              event_value: action.payload.data.total,
                              UserID: (defaultState.auth.userId) ?  defaultState.auth.userId : 'noAuth'
                              
                         })

                         // before uncommenting this add gtag.js script in index.html
                         // window.gtag('event', 'Click', {
                         //      'event_category': 'SearchByCategory',
                         //      'event_label': 'test-label',
                         //      'value': 10
                         // });
                    }
               }

               defaultState.searchReducer.articleList = { ...action.payload };
               state = { ...state, ...defaultState.searchReducer };

               break;
          case actionType.SEARCH_ARTICLE_FAILURE:
               defaultState.searchReducer.articleList = { ...action.payload };
               state = { ...state, ...defaultState.searchReducer };
               break;
          case actionType.SAVE_SEARCH_OPTION:

               defaultState.searchReducer.searchOption = Object.assign(defaultState.searchReducer.searchOption, action.payload.searchOption);

               state = { ...state, ...defaultState.searchReducer };

               break;

          default:
               state = { ...state };
               break;
     }

     return state;
};
export default reducer;